<!--Computation Section-->
<div class="container">
  <div class="offset-1 col-10">
    <mat-accordion>
      <mat-expansion-panel [expanded]="panelOpenState2"
                            (opened)="panelOpenState2 = true"
                            (closed)="panelOpenState2 = false">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Constraints
          </mat-panel-title>
          <mat-panel-description *ngIf="!panelOpenState2">
            <span *ngIf="currentCluster.nb_components>0">Turnover: {{ investableParameters.trading_budget | percent:'.1' }} --- </span><span *ngIf="!currentCluster.is_standalone">&nbsp;Cash: {{ investableParameters.additional_cash | percent:'.1' }}</span>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div class="row">
          <div class="col-6" style="line-height: 30px" *ngIf="!currentCluster.is_standalone">
            <div class="w-100" style="border-top:1px dotted grey"></div>
          </div>
          <div [ngClass]="{'col-6':true, 'offset-3':currentCluster.is_standalone}" style="line-height: 30px">
            <div class="w-100" style="border-top:1px dotted grey"></div>
          </div>
          <div class="col-6" style="line-height: 30px" *ngIf="currentCluster.nb_components>0">
            <span style="color: grey">Trading Budget</span>
            <span class="float-right">{{ investableParameters.trading_budget | percent:'.1' }}</span>
          </div>
          <div class="col-6" style="line-height: 30px" *ngIf="currentCluster.nb_components>0">
            <span style="color: grey">Constraints on weights</span>
            <span class="float-right">{{ investableParameters.has_weight_constraints ? 'Yes' : 'No' }}</span>
          </div>
          <div class="col-6" style="line-height: 30px" *ngIf="!currentCluster.is_standalone">
            <span style="color: grey">Additional Cash</span>
            <span class="float-right">{{ investableParameters.additional_cash | percent:'.1' }}</span>
            <div class="w-100" style="border-bottom:1px dotted grey"></div>
          </div>
          <div [ngClass]="{'col-6':true, 'offset-3':currentCluster.is_standalone}" style="line-height: 30px">
            <span style="color: grey">Completeness ingredients</span>
            <span class="float-right">{{ investableParameters.completeness_products.length }}</span>
            <div class="w-100" style="border-bottom:1px dotted grey"></div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <!-- Run Optimization button -->
    <div *ngIf="!optimizeOk && !improveYesNo" class="row mt-3">
      <div class="col text-center">
        <app-button [disabled]="!(investableParameters.completeness_products.length>1) || isComputing" (click)="onOptimize()">Run Optimization</app-button>
      </div>
      <br><br>
    </div>
  </div>
</div>
<!--Computation Section-->

<!-- Optimization results -->
<div class="container mt-3" *ngIf="optimizeOk && !hasImprove">
  <div class="offset-1 col-10">

    <div class=" card card-chart">
      <div class=" card-header">
        <div class=" row">
          <div class=" col-sm-6 text-left">
            <h5 class=" card-category">Investment Solution</h5>
            <h2 class=" card-title"><i class="fas fa-magic fa-lg"></i>&nbsp;&nbsp;&nbsp; Optimization</h2>
          </div>
          <div class=" col-sm-6">
            <div class=" btn-group float-right">
              <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage2=='weights'}"
                      (click)="selectedPage2='weights'">Weights</label>
              <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage2=='analytics'}"
                      (click)="selectedPage2='analytics';selectedOptimizationTab='perfRisk'">Analytics</label>
              <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage2=='ratings'}"
                      (click)="selectedPage2='ratings'">Robustness</label>
              <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage2=='distance'}"
                      (click)="selectedPage2='distance'">Distance</label>
            </div>
          </div>

        </div>
      </div>
      <div class=" card-body">
        <div *ngIf="selectedPage2=='weights'">
          <!-- Weighting table -->
          <table *ngIf="hasInvestable" mdbTable small="true">
            <thead>
              <tr>
                <th scope="col">Components</th>
                <th style="width:100px" *ngIf="!currentCluster.is_standalone">Original</th>
                <th style="width:100px" *ngIf="!currentCluster.is_standalone">Post Optimization</th>
                <th style="width:100px">Investable</th>
              </tr>
            </thead>
            <tbody *ngIf="!currentCluster.is_standalone">
              <tr *ngFor="let component of currentInvestable.weighting.components">
                <th class="ellipsis" scope="row">
                  <span mdbTooltip="{{ component.name }}">{{ component.name }}</span>
                </th>
                <td>{{ component.weight | percent:'.1' }}</td>
                <td>{{ component.post_optim_weight | percent:'.1' }}</td>
                <td>{{ component.investable_weight | percent:'.1' }}</td>
              </tr>
            </tbody>
            <thead *ngIf="currentInvestable.weighting.completeness.length>0 && !currentCluster.is_standalone">
              <tr>
                <th scope="col">Completeness</th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody *ngIf="currentInvestable.weighting.completeness.length>0">
              <tr *ngFor="let component of currentInvestable.weighting.completeness">
                <th class="ellipsis" scope="row">
                  <span mdbTooltip="{{ component.name }}">{{ component.name }}</span>
                </th>
                <td *ngIf="!currentCluster.is_standalone">—</td>
                <td *ngIf="!currentCluster.is_standalone">{{ component.post_optim_weight | percent:'.1' }}</td>
                <td>{{ component.investable_weight | percent:'.1' }}</td>
              </tr>
            </tbody>
          </table>
          <!-- Weighting table -->
        </div>
        <div *ngIf="selectedPage2=='distance'">
          <!-- Distance table -->
          <table *ngIf="!currentCluster.is_standalone" mdbTable small="true">
            <thead>
              <tr>
                <th scope="col" width="40%"></th>
                <th>Original</th>
                <th *ngIf="hasStrategy">{{ currentStrategy.name }}</th>
                <td *ngIf="!hasStrategy">—</td>
                <th>Investable</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th class="casino" scope="row">Factor Intensity</th>
                <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.factor_intensity['inception'] | number:'1.2-2' }}</td>
                <td *ngIf="!hasOriginal">—</td>
                <td *ngIf="hasStrategy">{{ currentStrategy.factorAnalysis.exposure.factor_intensity['inception'] | number:'1.2-2' }}</td>
                <td *ngIf="!hasStrategy">—</td>
                <td *ngIf="hasInvestable">{{ currentInvestable.factorAnalysis.exposure.factor_intensity['inception'] | number:'1.2-2' }}</td>
                <td *ngIf="!hasInvestable">—</td>
              </tr>
              <tr *ngIf="hasInvestable">
                <th class="casino" scope="row">Absolute Beta Distance</th>
                <td>{{ currentInvestable.distance.original.absolute_beta_distance | number:'1.2-2' }}</td>
                <td>—</td>
                <td>{{ currentInvestable.distance.investable.absolute_beta_distance | number:'1.2-2' }}</td>
              </tr>
              <tr *ngIf="hasInvestable">
                <th class="casino" scope="row">Relative Beta Distance</th>
                <td>{{ currentInvestable.distance.original.relative_beta_distance | number:'1.2-2' }}</td>
                <td>—</td>
                <td>{{ currentInvestable.distance.investable.relative_beta_distance | number:'1.2-2' }}</td>
              </tr>
              <tr *ngIf="hasInvestable">
                <th class="casino" scope="row">Absolute Improvement</th>
                <td>—</td>
                <td>—</td>
                <td>{{ currentInvestable.distance.investable.absolute_improvement | percent:'.1' }}</td>
              </tr>
              <tr *ngIf="hasInvestable">
                <th class="casino" scope="row">Relative Improvement</th>
                <td>—</td>
                <td>—</td>
                <td>{{ currentInvestable.distance.investable.relative_improvement | percent:'.1' }}</td>
              </tr>
            </tbody>
          </table>
          <table *ngIf="currentCluster.is_standalone" mdbTable small="true">
            <thead>
              <tr>
                <th scope="col" width="40%"></th>
                <th *ngIf="hasStrategy">{{ currentStrategy.name }}</th>
                <td *ngIf="!hasStrategy">—</td>
                <th>Investable</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th class="casino" scope="row">Factor Intensity</th>
                <td *ngIf="hasStrategy">{{ currentStrategy.factorAnalysis.exposure.factor_intensity['inception'] | number:'1.2-2' }}</td>
                <td *ngIf="!hasStrategy">—</td>
                <td *ngIf="hasInvestable">{{ currentInvestable.factorAnalysis.exposure.factor_intensity['inception'] | number:'1.2-2' }}</td>
                <td *ngIf="!hasInvestable">—</td>
              </tr>
              <tr *ngIf="hasInvestable">
                <th class="casino" scope="row">Absolute Beta Distance</th>
                <td>—</td>
                <td>{{ currentInvestable.distance.investable.absolute_beta_distance | number:'1.2-2' }}</td>
              </tr>
              <tr *ngIf="hasInvestable">
                <th class="casino" scope="row">Relative Beta Distance</th>
                <td>—</td>
                <td>{{ currentInvestable.distance.investable.relative_beta_distance | number:'1.2-2' }}</td>
              </tr>
            </tbody>
          </table>
          <!-- Distance table -->
        </div>
        <div *ngIf="selectedPage2=='analytics'">
          <mat-tab-group mat-align-tabs="center" animationDuration="0ms" (selectedTabChange)="onComponentsTabChange($event)">
            <!--    .                                      -->
            <!--   / \   Do not change mat-tab labels.     -->
            <!--  / ! \  They are used in typescript code. -->
            <!-- /_____\                                   -->
            <mat-tab label="Performance & Risk"></mat-tab>
            <mat-tab label="Exposure"></mat-tab>
            <mat-tab label="Diversification"></mat-tab>
          </mat-tab-group>

          <br />
          <!-- Perf. & Risk table -->
          <table *ngIf="selectedOptimizationTab=='perfRisk'" mdbTable small="true">
            <thead>
            <tr>
              <th scope="col" width="35%"></th>
              <th *ngIf="hasOriginal">Original</th>
              <th *ngIf="hasStrategy">{{ currentStrategy.name }}</th>
              <th *ngIf="hasInvestable">Investable</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th class="casino" scope="row">Returns</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.returns.inception | percent:'.1' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.performanceRiskAnalysis.returns.inception | percent:'.1' }}</td>
              <td *ngIf="hasInvestable">{{ currentInvestable.performanceRiskAnalysis.returns.inception | percent:'.1' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Volatility</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.volatility.inception | percent:'.1' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.performanceRiskAnalysis.volatility.inception | percent:'.1' }}</td>
              <td *ngIf="hasInvestable">{{ currentInvestable.performanceRiskAnalysis.volatility.inception | percent:'.1' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Sharpe ratio</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.sharpe_ratio.inception | number:'1.2-2' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.performanceRiskAnalysis.sharpe_ratio.inception | number:'1.2-2' }}</td>
              <td *ngIf="hasInvestable">{{ currentInvestable.performanceRiskAnalysis.sharpe_ratio.inception | number:'1.2-2' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Max Drawdown</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.maximum_drawdown.inception | percent:'.1' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.performanceRiskAnalysis.maximum_drawdown.inception | percent:'.1' }}</td>
              <td *ngIf="hasInvestable">{{ currentInvestable.performanceRiskAnalysis.maximum_drawdown.inception | percent:'.1' }}</td>
            </tr>
            </tbody>
            <thead>
              <tr>
                <th scope="col" width="35%"></th>
                <th *ngIf="hasOriginal"></th>
                <th *ngIf="hasStrategy"></th>
                <th *ngIf="hasInvestable"></th>
              </tr>
            </thead>
            <tbody>
            <tr>
              <th class="casino" scope="row">Excess Returns</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.excess_returns.inception | percent:'.1' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.performanceRiskAnalysis.excess_returns.inception | percent:'.1' }}</td>
              <td *ngIf="hasInvestable">{{ currentInvestable.performanceRiskAnalysis.excess_returns.inception | percent:'.1' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Tracking Error</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.tracking_error.inception | percent:'.1' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.performanceRiskAnalysis.tracking_error.inception | percent:'.1' }}</td>
              <td *ngIf="hasInvestable">{{ currentInvestable.performanceRiskAnalysis.tracking_error.inception | percent:'.1' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Information ratio</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.information_ratio.inception | number:'1.2-2' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.performanceRiskAnalysis.information_ratio.inception | number:'1.2-2' }}</td>
              <td *ngIf="hasInvestable">{{ currentInvestable.performanceRiskAnalysis.information_ratio.inception | number:'1.2-2' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Max Relative Drawdown</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.maximum_relative_drawdown.inception | percent:'.1' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.performanceRiskAnalysis.maximum_relative_drawdown.inception | percent:'.1' }}</td>
              <td *ngIf="hasInvestable">{{ currentInvestable.performanceRiskAnalysis.maximum_relative_drawdown.inception | percent:'.1' }}</td>
            </tr>
            </tbody>
          </table>
          <!-- Perf. & Risk table -->

          <!-- Exposure table -->
          <table *ngIf="selectedOptimizationTab=='exposure'" mdbTable small="true">
            <thead>
            <tr>
              <th scope="col" width="40%"></th>
              <th *ngIf="hasOriginal">Original</th>
              <th *ngIf="hasStrategy">{{ currentStrategy.name }}</th>
              <th *ngIf="hasInvestable">Investable</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th class="casino" scope="row">Size</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.size['inception'] | percent:'.1' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.factorAnalysis.exposure.size['inception'] | percent:'.1' }}</td>
              <td *ngIf="currentInvestable">{{ currentInvestable.factorAnalysis.exposure.size.inception | percent:'.1' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Value</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.value['inception'] | percent:'.1' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.factorAnalysis.exposure.value['inception'] | percent:'.1' }}</td>
              <td *ngIf="currentInvestable">{{ currentInvestable.factorAnalysis.exposure.value.inception | percent:'.1' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Momentum</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.momentum['inception'] | percent:'.1' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.factorAnalysis.exposure.momentum['inception'] | percent:'.1' }}</td>
              <td *ngIf="currentInvestable">{{ currentInvestable.factorAnalysis.exposure.momentum.inception | percent:'.1' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Volatility</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.volatility['inception'] | percent:'.1' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.factorAnalysis.exposure.volatility['inception'] | percent:'.1' }}</td>
              <td *ngIf="currentInvestable">{{ currentInvestable.factorAnalysis.exposure.volatility.inception | percent:'.1' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">High Yield</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.high_yield['inception'] | percent:'.1' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.factorAnalysis.exposure.high_yield['inception'] | percent:'.1' }}</td>
              <td *ngIf="currentInvestable">{{ currentInvestable.factorAnalysis.exposure.high_yield.inception | percent:'.1' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Quality</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.quality['inception'] | percent:'.1' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.factorAnalysis.exposure.quality['inception'] | percent:'.1' }}</td>
              <td *ngIf="hasInvestable">{{ currentInvestable.factorAnalysis.exposure.quality.inception | percent:'.1' }}</td>
            </tr>
            </tbody>
          </table>
          <!-- Exposure table -->

          <!-- Diversification table -->
          <table *ngIf="selectedOptimizationTab=='diversification'" mdbTable small="true">
            <thead>
            <tr>
              <th scope="col" width="40%"></th>
              <th *ngIf="hasOriginal">Original</th>
              <th *ngIf="hasStrategy">{{ currentStrategy.name }}</th>
              <th *ngIf="hasInvestable">Investable</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th class="casino" scope="row">Factor Intensity</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.factor_intensity['inception'] | number:'1.2-2' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.factorAnalysis.exposure.factor_intensity['inception'] | number:'1.2-2' }}</td>
              <td *ngIf="hasInvestable">{{ currentInvestable.factorAnalysis.exposure.factor_intensity['inception'] | number:'1.2-2' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Effective Number of Factors</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.diversification.effective_nb_of_factors | number:'1.2-2' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.factorAnalysis.diversification.effective_nb_of_factors | number:'1.2-2' }}</td>
              <td *ngIf="hasInvestable">{{ currentInvestable.factorAnalysis.diversification.effective_nb_of_factors | number:'1.2-2' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Deconcentration Rating</th>
              <td *ngIf="hasOriginal">
                <app-rating-span [rating]="currentOriginal.factorAnalysis.diversification.factor_deconcentration_quality_rating"></app-rating-span>
              </td>
              <td *ngIf="hasStrategy">
                <app-rating-span [rating]="currentStrategy.factorAnalysis.diversification.factor_deconcentration_quality_rating"></app-rating-span>
              </td>
              <td *ngIf="hasInvestable">
                <app-rating-span [rating]="currentInvestable.factorAnalysis.diversification.factor_deconcentration_quality_rating"></app-rating-span>
              </td>
            </tr>
            <tr>
              <th class="casino" scope="row">Effective Number of Risks</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.diversification.effective_nb_of_factor_bets | number:'1.2-2' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.factorAnalysis.diversification.effective_nb_of_factor_bets | number:'1.2-2' }}</td>
              <td *ngIf="hasInvestable">{{ currentInvestable.factorAnalysis.diversification.effective_nb_of_factor_bets | number:'1.2-2' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Diversification Rating</th>
              <td *ngIf="hasOriginal">
                <app-rating-span [rating]="currentOriginal.factorAnalysis.diversification.factor_diversification_quality_rating"></app-rating-span>
              </td>
              <td *ngIf="hasStrategy">
                <app-rating-span [rating]="currentStrategy.factorAnalysis.diversification.factor_diversification_quality_rating"></app-rating-span>
              </td>
              <td *ngIf="hasInvestable">
                <app-rating-span [rating]="currentInvestable.factorAnalysis.diversification.factor_diversification_quality_rating"></app-rating-span>
              </td>
            </tr>
            </tbody>
          </table>
          <!-- Diversification table -->
        </div>
        <div *ngIf="selectedPage2=='ratings'">
          <!-- Robustness table -->
          <table mdbTable small="true">
            <thead>
            <tr>
              <th scope="col" width="35%"></th>
              <th *ngIf="hasOriginal">Original</th>
              <th *ngIf="hasStrategy">{{ currentStrategy.name }}</th>
              <th *ngIf="hasInvestable">Investable</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th class="casino" scope="row">Performance</th>
              <td *ngIf="hasOriginal">
                <app-rating-span [rating]="currentOriginal.robustnessAnalysis.conditional_performance.conditional_performance_rating"></app-rating-span>
              </td>
              <td *ngIf="hasStrategy">
                <app-rating-span [rating]="currentStrategy.robustnessAnalysis.conditional_performance.conditional_performance_rating"></app-rating-span>
              </td>
              <td *ngIf="hasInvestable">
                <app-rating-span [rating]="currentInvestable.robustnessAnalysis.conditional_performance.conditional_performance_rating"></app-rating-span>
              </td>
            </tr>
            <tr>
              <th class="casino" scope="row">Risk</th>
              <td *ngIf="hasOriginal">
                <app-rating-span [rating]="currentOriginal.robustnessAnalysis.worst_rolling_risk_statistics.worst_rolling_risk_statistics_rating"></app-rating-span>
              </td>
              <td *ngIf="hasStrategy">
                <app-rating-span [rating]="currentStrategy.robustnessAnalysis.worst_rolling_risk_statistics.worst_rolling_risk_statistics_rating"></app-rating-span>
              </td>
              <td *ngIf="hasInvestable">
                <app-rating-span [rating]="currentInvestable.robustnessAnalysis.worst_rolling_risk_statistics.worst_rolling_risk_statistics_rating"></app-rating-span>
              </td>
            </tr>
            <tr>
              <th class="casino" scope="row">Outperformance</th>
              <td *ngIf="hasOriginal">
                <app-rating-span [rating]="currentOriginal.robustnessAnalysis.outperformance_probability.outperformance_probability_rating"></app-rating-span>
              </td>
              <td *ngIf="hasStrategy">
                <app-rating-span [rating]="currentStrategy.robustnessAnalysis.outperformance_probability.outperformance_probability_rating"></app-rating-span>
              </td>
              <td *ngIf="hasInvestable">
                <app-rating-span [rating]="currentInvestable.robustnessAnalysis.outperformance_probability.outperformance_probability_rating"></app-rating-span>
              </td>
            </tr>
            <tr>
              <th class="casino" scope="row">Global Rating</th>
              <td *ngIf="hasOriginal">
                <app-rating-span [rating]="currentOriginal.robustnessAnalysis.global_robustness_rating"></app-rating-span>
              </td>
              <td *ngIf="hasStrategy">
                <app-rating-span [rating]="currentStrategy.robustnessAnalysis.global_robustness_rating"></app-rating-span>
              </td>
              <td *ngIf="hasInvestable">
                <app-rating-span [rating]="currentInvestable.robustnessAnalysis.global_robustness_rating"></app-rating-span>
              </td>
            </tr>
            </tbody>
          </table>
          <!-- Robustness table -->
        </div>
      </div>
    </div>

    <div *ngIf="selectedPage2=='distance'" class=" card card-chart" style="margin-top: 20px;">
      <div class=" card-header">
        <div class=" row">
          <div class=" col-12 text-center">
            <h2 class=" card-title">Distance</h2>
          </div>
        </div>
      </div>
      <div class=" card-body">
        <app-peers-widget-chart *ngIf="(optimizeOk || improveOk) && (hasOriginal||currentCluster.is_standalone) && hasStrategy && hasInvestable"
                                [peerProducts]="[]" target="deconcentration"
                                [originalPA]="currentCluster.is_standalone ? undefined : currentOriginal.peerAnalysis"
                                [adjustedTargetPA]="currentStrategy.peerAnalysis"
                                [investablePA]="currentInvestable.peerAnalysis"></app-peers-widget-chart>
      </div>
    </div>
  </div>
</div>
<!-- Optimization results -->

<!-- Improve the solution? --
<div class="container" *ngIf="optimizeOk">
  <div class="offset-1 col-10">
    <br>
    <mat-checkbox [disabled]="isComputing" class="example-margin" [(ngModel)]="improveYesNo" (change)="onImproveCheck('improve_solution')">Would you like to improve this solution?</mat-checkbox>
  </div>
</div>
!-- Improve the solution? -->

<!-- Improve the solution parameters -->
<div class="container" *ngIf="improveYesNo">
  <div class="offset-1 col-10">
    <div class=" card card-chart">
      <div class=" card-header">
        <div class=" row">
          <div class=" col-sm-6 text-left">
            <h5 class=" card-category">Investment Solution</h5>
            <h2 class=" card-title">Improve the optimization</h2>
          </div>
        </div>
      </div>
      <div class=" card-body">
        <div class="row">
          <div class="offset-1 col-5" style="line-height: 30px">
            <mat-checkbox class="example-margin" [(ngModel)]="investableParameters.has_best_fit" [disabled]="true" (change)="onImproveCheck('best_fit')">Best Fit selection</mat-checkbox>
          </div>
          <div class="offset-1 col-5" style="line-height: 30px">
            <mat-checkbox class="example-margin" [(ngModel)]="investableParameters.has_remove_weight_constraints" [disabled]="isComputing" (change)="onImproveCheck('remove_weight_constraints')">Remove constraints on weights</mat-checkbox>
          </div>
          <div class="offset-1 col-5" style="line-height: 30px">
            <mat-checkbox class="example-margin" [(ngModel)]="investableParameters.has_volatility_constraints" [disabled]="isComputing" (change)="onImproveCheck('volatility_constraints')">Constraint on volatility</mat-checkbox>
          </div>
          <div class="offset-1 col-5" style="line-height: 30px">
            <mat-checkbox class="example-margin" [(ngModel)]="investableParameters.has_tracking_error_constraints" [disabled]="isComputing" (change)="onImproveCheck('tracking_error_constraints')">Constraint on tracking error</mat-checkbox>
          </div>
          <div class="col-6 text-center" style="line-height: 30px">
            <span *ngIf="investableParameters.has_volatility_constraints" class="mx-2">Volatility: {{ investableParameters.target_volatility | percent:'.1' }}</span>
          </div>
          <div class="col-6 text-center" style="line-height: 30px">
            <span *ngIf="investableParameters.has_tracking_error_constraints" class="mx-2">Tracking Error: {{ investableParameters.target_tracking_error | percent:'.2' }}</span>
          </div>
          <div *ngIf="investableParameters.has_volatility_constraints" class="col-6 mt-3" style="line-height: 30px">
            <mat-slider thumbLabel class="w-100" style="margin-top: -15px"
                        [displayWith]="formatLabel"
                        [(value)]="investableParameters.target_volatility"
                        [step]="0.001"
                        [disabled]="isComputing"
                        [min]="investableParameters.min_volatility" [max]="investableParameters.max_volatility"></mat-slider>
          </div>
          <div *ngIf="investableParameters.has_tracking_error_constraints" class="offset-6 col-6 mt-3" style="line-height: 30px">
            <mat-slider thumbLabel class="w-100" style="margin-top: -15px"
                        [displayWith]="formatLabel"
                        [(value)]="investableParameters.target_tracking_error"
                        [step]="0.0001"
                        [disabled]="isComputing"
                        [min]="investableParameters.min_tracking_error" [max]="investableParameters.max_tracking_error"></mat-slider>
          </div>
        </div>
      </div>
      <div *ngIf="hasImprove" class=" card-footer">
        <!-- re-Run Optimization button -->
        <div class="row">
          <div class="col text-center">
            <app-button [disabled]="isComputing" (click)="onImprove()">Run Optimization</app-button>
          </div>
        </div>
      </div>
    </div>
    <br>
  </div>
</div>
<!-- Improve the solution parameters -->

<!-- Optimization results -->
<div class="container" *ngIf="improveOk && hasImprove">
  <div class="offset-1 col-10">

    <div class=" card card-chart">
      <div class=" card-header">
        <div class=" row">
          <div class=" col-sm-6 text-left">
            <h5 class=" card-category">Investment Solution</h5>
            <h2 class=" card-title"><i class="fas fa-magic fa-lg"></i>&nbsp;&nbsp;&nbsp; Optimization</h2>
          </div>
          <div class=" col-sm-6">
            <div class=" btn-group float-right">
              <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage2=='weights'}"
                      (click)="selectedPage2='weights'">Weights</label>
              <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage2=='analytics'}"
                      (click)="selectedPage2='analytics';selectedOptimizationTab='perfRisk'">Analytics</label>
              <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage2=='ratings'}"
                      (click)="selectedPage2='ratings'">Robustness</label>
              <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage2=='distance'}"
                      (click)="selectedPage2='distance'">Distance</label>
            </div>
          </div>

        </div>
      </div>
      <div class=" card-body">
        <div *ngIf="selectedPage2=='weights'">
          <!-- Weighting table -->
          <table *ngIf="hasInvestable" mdbTable small="true">
            <thead>
              <tr>
                <th scope="col">Components</th>
                <th style="width:100px" *ngIf="!currentCluster.is_standalone">Original</th>
                <th style="width:100px" *ngIf="!currentCluster.is_standalone">Post Optimization</th>
                <th style="width:100px">Investable</th>
              </tr>
            </thead>
            <tbody *ngIf="!currentCluster.is_standalone">
              <tr *ngFor="let component of currentInvestable.weighting.components">
                <th class="ellipsis" scope="row">
                  <span mdbTooltip="{{ component.name }}">{{ component.name }}</span>
                </th>
                <td>{{ component.weight | percent:'.1' }}</td>
                <td>{{ component.post_optim_weight | percent:'.1' }}</td>
                <td>{{ component.investable_weight | percent:'.1' }}</td>
              </tr>
            </tbody>
            <thead *ngIf="currentInvestable.weighting.completeness.length>0 && !currentCluster.is_standalone">
              <tr>
                <th scope="col">Completeness</th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody *ngIf="currentInvestable.weighting.completeness.length>0">
              <tr *ngFor="let component of currentInvestable.weighting.completeness">
                <th class="ellipsis" scope="row">
                  <span mdbTooltip="{{ component.name }}">{{ component.name }}</span>
                </th>
                <td *ngIf="!currentCluster.is_standalone">—</td>
                <td *ngIf="!currentCluster.is_standalone">{{ component.post_optim_weight | percent:'.1' }}</td>
                <td>{{ component.investable_weight | percent:'.1' }}</td>
              </tr>
            </tbody>
          </table>
          <!-- Weighting table -->
        </div>
        <div *ngIf="selectedPage2=='distance'">
          <!-- Distance table -->
          <table *ngIf="!currentCluster.is_standalone" mdbTable small="true">
            <thead>
              <tr>
                <th scope="col" width="40%"></th>
                <th>Original</th>
                <th *ngIf="hasStrategy">{{ currentStrategy.name }}</th>
                <td *ngIf="!hasStrategy">—</td>
                <th>Investable</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th class="casino" scope="row">Factor Intensity</th>
                <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.factor_intensity['inception'] | number:'1.2-2' }}</td>
                <td *ngIf="!hasOriginal">—</td>
                <td *ngIf="hasStrategy">{{ currentStrategy.factorAnalysis.exposure.factor_intensity['inception'] | number:'1.2-2' }}</td>
                <td *ngIf="!hasStrategy">—</td>
                <td *ngIf="hasInvestable">{{ currentInvestable.factorAnalysis.exposure.factor_intensity['inception'] | number:'1.2-2' }}</td>
                <td *ngIf="!hasInvestable">—</td>
              </tr>
              <tr *ngIf="hasInvestable">
                <th class="casino" scope="row">Absolute Beta Distance</th>
                <td>{{ currentInvestable.distance.original.absolute_beta_distance | number:'1.2-2' }}</td>
                <td>—</td>
                <td>{{ currentInvestable.distance.investable.absolute_beta_distance | number:'1.2-2' }}</td>
              </tr>
              <tr *ngIf="hasInvestable">
                <th class="casino" scope="row">Relative Beta Distance</th>
                <td>{{ currentInvestable.distance.original.relative_beta_distance | number:'1.2-2' }}</td>
                <td>—</td>
                <td>{{ currentInvestable.distance.investable.relative_beta_distance | number:'1.2-2' }}</td>
              </tr>
              <tr *ngIf="hasInvestable">
                <th class="casino" scope="row">Absolute Improvement</th>
                <td>—</td>
                <td>—</td>
                <td>{{ currentInvestable.distance.investable.absolute_improvement | percent:'.1' }}</td>
              </tr>
              <tr *ngIf="hasInvestable">
                <th class="casino" scope="row">Relative Improvement</th>
                <td>—</td>
                <td>—</td>
                <td>{{ currentInvestable.distance.investable.relative_improvement | percent:'.1' }}</td>
              </tr>
            </tbody>
          </table>
          <table *ngIf="currentCluster.is_standalone" mdbTable small="true">
            <thead>
              <tr>
                <th scope="col" width="40%"></th>
                <th *ngIf="hasStrategy">{{ currentStrategy.name }}</th>
                <td *ngIf="!hasStrategy">—</td>
                <th>Investable</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th class="casino" scope="row">Factor Intensity</th>
                <td *ngIf="hasStrategy">{{ currentStrategy.factorAnalysis.exposure.factor_intensity['inception'] | number:'1.2-2' }}</td>
                <td *ngIf="!hasStrategy">—</td>
                <td *ngIf="hasInvestable">{{ currentInvestable.factorAnalysis.exposure.factor_intensity['inception'] | number:'1.2-2' }}</td>
                <td *ngIf="!hasInvestable">—</td>
              </tr>
              <tr *ngIf="hasInvestable">
                <th class="casino" scope="row">Absolute Beta Distance</th>
                <td>—</td>
                <td>{{ currentInvestable.distance.investable.absolute_beta_distance | number:'1.2-2' }}</td>
              </tr>
              <tr *ngIf="hasInvestable">
                <th class="casino" scope="row">Relative Beta Distance</th>
                <td>—</td>
                <td>{{ currentInvestable.distance.investable.relative_beta_distance | number:'1.2-2' }}</td>
              </tr>
            </tbody>
          </table>
          <!-- Distance table -->
        </div>
        <div *ngIf="selectedPage2=='analytics'">
          <mat-tab-group mat-align-tabs="center" animationDuration="0ms" (selectedTabChange)="onComponentsTabChange($event)">
            <!--    .                                      -->
            <!--   / \   Do not change mat-tab labels.     -->
            <!--  / ! \  They are used in typescript code. -->
            <!-- /_____\                                   -->
            <mat-tab label="Performance & Risk"></mat-tab>
            <mat-tab label="Exposure"></mat-tab>
            <mat-tab label="Diversification"></mat-tab>
          </mat-tab-group>

          <br />
          <!-- Perf. & Risk table -->
          <table *ngIf="selectedOptimizationTab=='perfRisk'" mdbTable small="true">
            <thead>
            <tr>
              <th scope="col" width="35%"></th>
              <th *ngIf="hasOriginal">Original</th>
              <th *ngIf="hasStrategy">{{ currentStrategy.name }}</th>
              <th *ngIf="hasInvestable">Investable</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th class="casino" scope="row">Returns</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.returns.inception | percent:'.1' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.performanceRiskAnalysis.returns.inception | percent:'.1' }}</td>
              <td *ngIf="hasInvestable">{{ currentInvestable.performanceRiskAnalysis.returns.inception | percent:'.1' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Volatility</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.volatility.inception | percent:'.1' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.performanceRiskAnalysis.volatility.inception | percent:'.1' }}</td>
              <td *ngIf="hasInvestable">{{ currentInvestable.performanceRiskAnalysis.volatility.inception | percent:'.1' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Sharpe ratio</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.sharpe_ratio.inception | number:'1.2-2' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.performanceRiskAnalysis.sharpe_ratio.inception | number:'1.2-2' }}</td>
              <td *ngIf="hasInvestable">{{ currentInvestable.performanceRiskAnalysis.sharpe_ratio.inception | number:'1.2-2' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Max Drawdown</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.maximum_drawdown.inception | percent:'.1' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.performanceRiskAnalysis.maximum_drawdown.inception | percent:'.1' }}</td>
              <td *ngIf="hasInvestable">{{ currentInvestable.performanceRiskAnalysis.maximum_drawdown.inception | percent:'.1' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Excess Returns</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.excess_returns.inception | percent:'.1' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.performanceRiskAnalysis.excess_returns.inception | percent:'.1' }}</td>
              <td *ngIf="hasInvestable">{{ currentInvestable.performanceRiskAnalysis.excess_returns.inception | percent:'.1' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Tracking Error</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.tracking_error.inception | percent:'.1' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.performanceRiskAnalysis.tracking_error.inception | percent:'.1' }}</td>
              <td *ngIf="hasInvestable">{{ currentInvestable.performanceRiskAnalysis.tracking_error.inception | percent:'.1' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Information ratio</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.information_ratio.inception | number:'1.2-2' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.performanceRiskAnalysis.information_ratio.inception | number:'1.2-2' }}</td>
              <td *ngIf="hasInvestable">{{ currentInvestable.performanceRiskAnalysis.information_ratio.inception | number:'1.2-2' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Max Relative Drawdown</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.maximum_relative_drawdown.inception | percent:'.1' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.performanceRiskAnalysis.maximum_relative_drawdown.inception | percent:'.1' }}</td>
              <td *ngIf="hasInvestable">{{ currentInvestable.performanceRiskAnalysis.maximum_relative_drawdown.inception | percent:'.1' }}</td>
            </tr>
            </tbody>
          </table>
          <!-- Perf. & Risk table -->

          <!-- Exposure table -->
          <table *ngIf="selectedOptimizationTab=='exposure'" mdbTable small="true">
            <thead>
            <tr>
              <th scope="col" width="40%"></th>
              <th *ngIf="hasOriginal">Original</th>
              <th *ngIf="hasStrategy">{{ currentStrategy.name }}</th>
              <th *ngIf="hasInvestable">Investable</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th class="casino" scope="row">Size</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.size['inception'] | percent:'.1' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.factorAnalysis.exposure.size['inception'] | percent:'.1' }}</td>
              <td *ngIf="currentInvestable">{{ currentInvestable.factorAnalysis.exposure.size.inception | percent:'.1' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Value</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.value['inception'] | percent:'.1' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.factorAnalysis.exposure.value['inception'] | percent:'.1' }}</td>
              <td *ngIf="currentInvestable">{{ currentInvestable.factorAnalysis.exposure.value.inception | percent:'.1' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Momentum</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.momentum['inception'] | percent:'.1' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.factorAnalysis.exposure.momentum['inception'] | percent:'.1' }}</td>
              <td *ngIf="currentInvestable">{{ currentInvestable.factorAnalysis.exposure.momentum.inception | percent:'.1' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Volatility</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.volatility['inception'] | percent:'.1' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.factorAnalysis.exposure.volatility['inception'] | percent:'.1' }}</td>
              <td *ngIf="currentInvestable">{{ currentInvestable.factorAnalysis.exposure.volatility.inception | percent:'.1' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">High Yield</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.high_yield['inception'] | percent:'.1' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.factorAnalysis.exposure.high_yield['inception'] | percent:'.1' }}</td>
              <td *ngIf="currentInvestable">{{ currentInvestable.factorAnalysis.exposure.high_yield.inception | percent:'.1' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Quality</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.quality['inception'] | percent:'.1' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.factorAnalysis.exposure.quality['inception'] | percent:'.1' }}</td>
              <td *ngIf="hasInvestable">{{ currentInvestable.factorAnalysis.exposure.quality.inception | percent:'.1' }}</td>
            </tr>
            </tbody>
          </table>
          <!-- Exposure table -->

          <!-- Diversification table -->
          <table *ngIf="selectedOptimizationTab=='diversification'" mdbTable small="true">
            <thead>
            <tr>
              <th scope="col" width="40%"></th>
              <th *ngIf="hasOriginal">Original</th>
              <th *ngIf="hasStrategy">{{ currentStrategy.name }}</th>
              <th *ngIf="hasInvestable">Investable</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th class="casino" scope="row">Factor Intensity</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.factor_intensity['inception'] | number:'1.2-2' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.factorAnalysis.exposure.factor_intensity['inception'] | number:'1.2-2' }}</td>
              <td *ngIf="hasInvestable">{{ currentInvestable.factorAnalysis.exposure.factor_intensity['inception'] | number:'1.2-2' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Effective Number of Factors</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.diversification.effective_nb_of_factors | number:'1.2-2' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.factorAnalysis.diversification.effective_nb_of_factors | number:'1.2-2' }}</td>
              <td *ngIf="hasInvestable">{{ currentInvestable.factorAnalysis.diversification.effective_nb_of_factors | number:'1.2-2' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Deconcentration Rating</th>
              <td *ngIf="hasOriginal">
                <app-rating-span [rating]="currentOriginal.factorAnalysis.diversification.factor_deconcentration_quality_rating"></app-rating-span>
              </td>
              <td *ngIf="hasStrategy">
                <app-rating-span [rating]="currentStrategy.factorAnalysis.diversification.factor_deconcentration_quality_rating"></app-rating-span>
              </td>
              <td *ngIf="hasInvestable">
                <app-rating-span [rating]="currentInvestable.factorAnalysis.diversification.factor_deconcentration_quality_rating"></app-rating-span>
              </td>
            </tr>
            <tr>
              <th class="casino" scope="row">Effective Number of Risks</th>
              <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.diversification.effective_nb_of_factor_bets | number:'1.2-2' }}</td>
              <td *ngIf="hasStrategy">{{ currentStrategy.factorAnalysis.diversification.effective_nb_of_factor_bets | number:'1.2-2' }}</td>
              <td *ngIf="hasInvestable">{{ currentInvestable.factorAnalysis.diversification.effective_nb_of_factor_bets | number:'1.2-2' }}</td>
            </tr>
            <tr>
              <th class="casino" scope="row">Diversification Rating</th>
              <td *ngIf="hasOriginal">
                <app-rating-span [rating]="currentOriginal.factorAnalysis.diversification.factor_diversification_quality_rating"></app-rating-span>
              </td>
              <td *ngIf="hasStrategy">
                <app-rating-span [rating]="currentStrategy.factorAnalysis.diversification.factor_diversification_quality_rating"></app-rating-span>
              </td>
              <td *ngIf="hasInvestable">
                <app-rating-span [rating]="currentInvestable.factorAnalysis.diversification.factor_diversification_quality_rating"></app-rating-span>
              </td>
            </tr>
            </tbody>
          </table>
          <!-- Diversification table -->

        </div>
        <div *ngIf="selectedPage2=='ratings'">
          <!-- Robustness table -->
          <table mdbTable small="true">
            <thead>
            <tr>
              <th scope="col" width="35%"></th>
              <th *ngIf="hasOriginal">Original</th>
              <th *ngIf="hasStrategy">{{ currentStrategy.name }}</th>
              <th *ngIf="hasInvestable">Investable</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th class="casino" scope="row">Performance</th>
              <td *ngIf="hasOriginal">
                <app-rating-span [rating]="currentOriginal.robustnessAnalysis.conditional_performance.conditional_performance_rating"></app-rating-span>
              </td>
              <td *ngIf="hasStrategy">
                <app-rating-span [rating]="currentStrategy.robustnessAnalysis.conditional_performance.conditional_performance_rating"></app-rating-span>
              </td>
              <td *ngIf="hasInvestable">
                <app-rating-span [rating]="currentInvestable.robustnessAnalysis.conditional_performance.conditional_performance_rating"></app-rating-span>
              </td>
            </tr>
            <tr>
              <th class="casino" scope="row">Risk</th>
              <td *ngIf="hasOriginal">
                <app-rating-span [rating]="currentOriginal.robustnessAnalysis.worst_rolling_risk_statistics.worst_rolling_risk_statistics_rating"></app-rating-span>
              </td>
              <td *ngIf="hasStrategy">
                <app-rating-span [rating]="currentStrategy.robustnessAnalysis.worst_rolling_risk_statistics.worst_rolling_risk_statistics_rating"></app-rating-span>
              </td>
              <td *ngIf="hasInvestable">
                <app-rating-span [rating]="currentInvestable.robustnessAnalysis.worst_rolling_risk_statistics.worst_rolling_risk_statistics_rating"></app-rating-span>
              </td>
            </tr>
            <tr>
              <th class="casino" scope="row">Outperformance</th>
              <td *ngIf="hasOriginal">
                <app-rating-span [rating]="currentOriginal.robustnessAnalysis.outperformance_probability.outperformance_probability_rating"></app-rating-span>
              </td>
              <td *ngIf="hasStrategy">
                <app-rating-span [rating]="currentStrategy.robustnessAnalysis.outperformance_probability.outperformance_probability_rating"></app-rating-span>
              </td>
              <td *ngIf="hasInvestable">
                <app-rating-span [rating]="currentInvestable.robustnessAnalysis.outperformance_probability.outperformance_probability_rating"></app-rating-span>
              </td>
            </tr>
            <tr>
              <th class="casino" scope="row">Global Rating</th>
              <td *ngIf="hasOriginal">
                <app-rating-span [rating]="currentOriginal.robustnessAnalysis.global_robustness_rating"></app-rating-span>
              </td>
              <td *ngIf="hasStrategy">
                <app-rating-span [rating]="currentStrategy.robustnessAnalysis.global_robustness_rating"></app-rating-span>
              </td>
              <td *ngIf="hasInvestable">
                <app-rating-span [rating]="currentInvestable.robustnessAnalysis.global_robustness_rating"></app-rating-span>
              </td>
            </tr>
            </tbody>
          </table>
          <!-- Robustness table -->
        </div>
      </div>
    </div>

    <div *ngIf="selectedPage2=='distance'" class=" card card-chart" style="margin-top: 20px;">
      <div class=" card-header">
        <div class=" row">
          <div class=" col-12 text-center">
            <h2 class=" card-title">Distance</h2>
          </div>
        </div>
      </div>
      <div class=" card-body">
        <app-peers-widget-chart *ngIf="(optimizeOk || improveOk) && (hasOriginal||currentCluster.is_standalone) && hasStrategy && hasInvestable"
                                [peerProducts]="[]" target="deconcentration"
                                [originalPA]="currentCluster.is_standalone ? undefined : currentOriginal.peerAnalysis"
                                [adjustedTargetPA]="currentStrategy.peerAnalysis"
                                [investablePA]="currentInvestable.peerAnalysis"></app-peers-widget-chart>
      </div>
    </div>

  </div>
</div>
<!-- Optimization results -->
